module.exports = __webpack_public_path__ + "img/plan.19f4295b.png";